@let c = circuit();
@let u = ui();

<section
  class="hd-circuit-info-full"
  [class.hd-circuit-info-full--floating]="isFloating"
>
  <header class="hd-circuit-info-full__header">
    <div class="hd-circuit-info-full__heading">
      @if (themeIcon(); as icon) {
        <i
          class="fa-regular fa-{{ icon }} hd-circuit-info-full__theme-icon"
          aria-hidden="true"
        ></i>
      }

      <div class="hd-circuit-info-full__heading-text">
        <h3 class="hd-circuit-info-full__title">{{ c.name }}</h3>
        @if (c.titleEn || c.type) {
          <p class="hd-circuit-info-full__subtitle">
            @if (c.titleEn) { <span class="hd-circuit-info-full__title-en">{{ c.titleEn }}</span> }
            @if (c.titleEn && c.type) { <span class="hd-circuit-info-full__sep">·</span> }
            @if (c.type) { <span class="hd-circuit-info-full__type">{{ c.type }}</span> }
          </p>
        }
      </div>
    </div>
  </header>

  <hd-circuit-info-kernwoorden
    [label]="u.kernwoordenLabel"
    [items]="c.kernwoorden"
  />

  <div class="hd-circuit-info-full__variant-row">
    <e-segmented-toggle
      testId="circuit-info-variant"
      [groupLabel]="u.variantSwitcherLabel"
      [options]="variantOptions()"
      [value]="variant()"
      (valueChange)="setVariant($event)"
    ></e-segmented-toggle>
  </div>

  <markdown
    class="hd-circuit-info-full__body"
    [src]="markdownSrc()"
  ></markdown>
</section>
